export default __webpack_public_path__ + "static/thumbnail-a3491ccef5fdf0eb202a543eb8205b3c.png";